import React from "react";
import t1 from "./Images/T1.svg";
import t2 from "./Images/T2.svg";
import t3 from "./Images/T3.svg";
import t4 from "./Images/T4.svg";
import t5 from "./Images/T5.svg";
import t6 from "./Images/T6.svg";
import "../styles/timeline.css";
import { Link } from "react-router-dom";

const Timeline = () => {
  return (
    <div className="Kbody">
      <div className="kTimeline">
        <div style={{ alignItems: "center", textAlign: "center" }}>
          <div className="kTimeline-heading">EVENT TIMELINE</div>
        </div>

        <div className="kTimeline-container">
          <img src={t1} alt="logo" />
          <div className="text-box">
            <h4>16 jan 2025</h4>
            <h2>Registration</h2>

            <p className="kTimeline-content">
              Register your team for Geekvishwa 2.0 on Unstop and complete the
              ₹199/- + GST payment via{" "}
              <Link to={"https://learner.vierp.in/events"}>VIERP</Link>,
              uploading the receipt during registration. Confirmation will be
              sent after verification—get ready for the hackathon!
            </p>
          </div>
        </div>
        <div className="kTimeline-container">
          <img src={t2} alt="logo" />
          <div className="text-box">
            <h4>20 jan 2025</h4>
            <h2>Problem Statement Release</h2>
            <p className="kTimeline-content">
              Get ready to brainstorm and plan your approach!
            </p>
          </div>
        </div>
        <div className="kTimeline-container">
          <img src={t3} alt="logo" />
          <div className="text-box">
            <h4>20-31 jan 2025</h4>
            <h2>PPT Submission</h2>
            <p className="kTimeline-content">
              Submit your presentation using the provided template by 31st
              January (11:59 PM). The judging panel will shortlist 40 teams for
              the final round.
            </p>
            <div className="kTimeline-content-btn">
              <a
                href="#target-section"
                style={{ textDecoration: "none", color: "white" }}
              >
                Round Details
              </a>
            </div>
          </div>
        </div>
        <div className="kTimeline-container">
          <img src={t4} alt="logo" />
          <div className="text-box">
            <h4>3 Feb 2025</h4>
            <h2>Announcement Of Shortlisted Teams</h2>
            <p className="kTimeline-content">
              Shortlisted teams will be notified by 3rd Feb, evening.
            </p>
          </div>
        </div>
        <div className="kTimeline-container">
          <img src={t5} alt="logo" />
          <div className="text-box">
            <h4>11 Feb 2025</h4>
            <h2>Prototype Presentation And Evaluation.</h2>
            <p className="kTimeline-content">
              The grand finale! Present your prototype and solution to the
              judging panel.
            </p>
            <div className="kTimeline-content-btn">
              <a
                href="#target2"
                style={{ textDecoration: "none", color: "white" }}
              >
                Round Details
              </a>
            </div>
          </div>
        </div>

        <div className="kTimeline-container">
          <img src={t6} alt="logo" />
          <div className="text-box">
            <h4>11 Feb 2025</h4>
            <h2>Winner Announcement</h2>
            <p className="kTimeline-content">
              Winner will be declared on the same day
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Timeline;
